import CONSTANTS from '../CONSTANTS';

const initialState = {
  studies: [],
  page: 0,
  lastPage: 1,
  limit: 20,
  totalEntries: 0,
  study: {},
  loadingAiReview: false,
  loadingStudy: false,
  loadingStudyList: false,
  showSentModal: false,
  querySearch: "",
  canVote: false,
  shouldUpdateStudyList: false,
  laborListScroll: 0,
  comingFromDetails: false,
  context: {}
}
const laboratoryReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case CONSTANTS.LAB_LOADING_STUDY_LIST:
      return {
        ...state,
        loadingStudyList: action.value
      };

    case CONSTANTS.LAB_SHOW_SENT_MODAL:
      return {
        ...state,
        showSentModal: action.value
      };

    case CONSTANTS.LAB_CAN_SAVE_REVIEW: {
      const study = {...state.study};
      study.review_delivery_enabled = action.value;
      return {
        ...state,
        study: study
      };
    }

    case CONSTANTS.LAB_LOADING_STUDY:
      return {
        ...state,
        loadingStudy: action.value
      };

    case CONSTANTS.LAB_SET_STUDIES:
      return { 
        ...state, 
        studies: [...action.studies.data],
        page: action.studies.page,
        lastPage: action.studies.lastPage,
        limit: action.studies.limit,
        totalEntries: action.studies.total,
        loadingStudyList: false
      };

    case CONSTANTS.LAB_SET_STUDY:
      return {
        ...state,
        study: {...action.study},
        loadingStudy: false,
      }
    
    case CONSTANTS.LAB_CAN_VOTE:
      return {...state, canVote: action.value}

    case CONSTANTS.LAB_LOADING_AI_COMMENT:
      return {
        ...state,
        loadingAiReview: action.value
      }

    case CONSTANTS.LAB_SAVE_TEMPLATE_LOCAL_DATA: {
      //Save template and review data locally to avoid requesting the entire studio
      let newTemplates = [], newReviews = [];
      if (state.study.templates) {
        let templateIndex = state.study.templates.map(te => te.name).indexOf(action.name);
        newTemplates = [...state.study.templates];
        if (templateIndex !== -1 && newTemplates[templateIndex]) {
          newTemplates[templateIndex].content = action.content;
          newTemplates[templateIndex].updated_at = Date.now();
        } else {
          newTemplates.push({
            name: action.name,
            content: action.content,
            updated_at: Date.now()
          });
        }
      }

      if (state.study.reviews) {
        newReviews = [...state.study.reviews];

        if (newReviews[0]) {
          newReviews[0].content = action.content;
          newReviews[0].template = {name: action.name};
          newReviews[0].updated_at = Date.now();
        } else {
          newReviews[0] = {
            content: action.content,
            updated_at: Date.now(),
            template: {name: action.name}
          }
        }
      }
      return {
        ...state,
        study: {
          ...state.study, 
          templates: [...newTemplates],
          reviews: [...newReviews]
        }
      };
    }

    case CONSTANTS.LAB_SET_SEARCH_QUERY: 
      return {
        ...state,
        querySearch: action.search
      }

    //Update study list invitation button locally
    case CONSTANTS.LAB_UPDATE_PATIENT_IN_LIST: {
      const currentDate = new Date(Date.now());
      const newStudyList = state.studies.map(s => {
        if (s.patient.pifs_id === action.patientId) {
          if (!s.patient.isTelepraxen) {
            //Patient was not in telepraxen, mark it as pending
            s.patient.isTelepraxen = 2;
            s.patient.invitations = [{
              sent_at: currentDate.toISOString(),
              type: "manual"
            }]
          } else if (s.patient.isTelepraxen === 2) {
            s.patient.invitations.push({
              sent_at: currentDate.toISOString(),
              type: "manual"
            });

            //Reverse invitations order
            s.patient.invitations = s.patient.invitations.reverse();
          }
        }

        return s;
      });

      return {
        ...state,
        studies: newStudyList
      }
    }

    case CONSTANTS.LAB_SAVE_SCROLL: {
      return {
        ...state,
        laborListScroll: action.scroll
      }
    }

    case CONSTANTS.LAB_COMING_FROM_DETAILS: {
      return {...state, comingFromDetails: action.val};
    }
    
    case CONSTANTS.LAB_SET_PAGE_INDEX: {
      return {...state, page: action.val};
    }

    case CONSTANTS.LAB_SET_CONTEXT: {
      return {...state, context: {...action.context}};
    }

    default:
      return state;
  }
};

export default laboratoryReducer;
